var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.082 20.3473L91.2468 32.9175M97.0673 4.95215L86.5819 27.1347M97.0673 4.95215H30.3055M97.0673 4.95215L109.087 20.3473V107.652L97.0673 123.047M86.5819 27.1347L91.2468 32.9132V48.5144M86.5819 27.1347H40.7909M103.14 48.5187V24.6919L93.5582 12.5424H33.8146L24.1908 24.6919V48.5187M18.2483 20.3473L36.126 32.9175M36.126 32.9175L40.7909 27.1347M36.126 32.9175V48.5187M30.3055 4.95215L40.7909 27.1347M30.3055 4.95215L18.2441 20.3473V107.652L30.3055 123.047M30.3097 48.5187V28.9507L37.5255 20.3473H89.8473L97.0673 28.9507V99.0488L89.8473 107.652H37.5255L30.3055 99.0488V48.5187M109.082 107.652L91.2468 95.0433M91.2468 95.0433L86.5819 100.865M91.2468 95.0433V48.523M97.0673 123.047L86.5819 100.865M97.0673 123.047H30.3055M86.5819 100.865H40.7909M103.14 48.523V103.265L93.5582 115.414H33.8146L24.1908 103.265V48.523M18.2483 107.652L36.126 95.0433M36.126 95.0433L40.7909 100.865M36.126 95.0433V48.523M30.3055 123.047L40.7909 100.865",
    stroke: "#151542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.150d127981f6e1cc5a9f91c0470dc5d8.svg";
export { ForwardRef as ReactComponent };